import utils from "../utils/utils";
import {fancybox} from "../components/fancybox";

const key = {
    localStorage: 'fancybox-message',
}

export function appendNonceToData(data, action) {
    data.push({name: "_wpnonce", value: utils.get_nonce()}, {name: "action", value: action});
    return data;
}

export function setDefaultSingleParameter(name, value) {
    let url = new URL(window.location.href);
    if (!url.searchParams.has(name)) {
        url.searchParams.set(name, value);
        window.history.pushState({}, '', url);
    }
}

export function setSingleParameter(name, value) {
    if (typeof value !== 'undefined' && value !== null) {
        let url = new URL(window.location.href);
        url.searchParams.set(name, value);
        window.history.pushState({}, '', url);
    }
}

export function getSingleParameter(name) {
    let url = new URL(window.location.href);
    return url.searchParams.get(name);
}

export function onLoadCheckFancyboxMessage() {
    const message = localStorage.getItem(key.localStorage);
    if (message) {
        fancybox.openFancybox(message);
        localStorage.removeItem(key.localStorage);
    }
}

export function setFancyboxMessage(message) {
    if (message) {
        localStorage.setItem(key.localStorage, message);
        location.reload();
    }
}

export function getTranslation(key) {
    return utils.get_js_translations()[key] || '';
}